import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { useJsApiLoader } from '@react-google-maps/api'

// Static libraries array to prevent reloading
const libraries = ['places']

const GoogleMapsLoader = ({ children, GOOGLE_MAPS_KEY }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_KEY,
    libraries
  })

  console.log('isLoaded ', isLoaded)
  console.log('loadError ', loadError)

  if (loadError) {
    console.error('Google Maps failed to load:', loadError)
    return <div>Error loading Google Maps</div>
  }
  if (!isLoaded) {
    return (
      <Box
        component="div"
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100vw">
        <CircularProgress color="primary" />
      </Box>
    )
  }

  return <>{children}</>
}
export default GoogleMapsLoader
